<template>
  <xn-form-group class="bg-muted text-white p-2 rounded-sm">
    <XnInput
      :value="newsletter"
      @change.native.prevent="changeNewsletter"
      label="Subscribe to the APROE Newsletter"
      type="checkbox"
      class="mt-0"
    />
  </xn-form-group>
</template>

<script>
import XnFormGroup from './primitives/XnFormGroup.vue'
import XnInput from './primitives/XnInput.vue'
export default {
  components: { XnFormGroup, XnInput },
  props: { newsletter: { type: Boolean } },
  methods: {
    changeNewsletter(evt) {
      this.$emit('handle-change-newsletter', evt.target.checked)
    },

  },
}
</script>